import { Inject, Injectable } from 'angular-ts-decorators';

import { CompareCheckboxAction } from '../models/compare-checkbox-action-type';
import { INotficationItem } from '../models/notification-item';

export interface ICompareCheckboxService {
  idsToCompare: number[];

  subscribe(): ng.IPromise<number[]>;
  isChecked(id: number): boolean;
  toggle(id: number): void;
  clearAll(ids: number[]): void;
}

const key = 'CompareCheckboxService';
const maxIds = 3;

@Injectable('compareCheckboxService')
export class CompareCheckboxService implements ICompareCheckboxService {
  public static $inject: ReadonlyArray<string> = ['$window', '$q'];

  private compareIds: number[] = [];
  private notificationDefer: ng.IDeferred<number[]>;

  constructor(
    @Inject('$window') private $window: ng.IWindowService,
    @Inject('$q') private $q: ng.IQService,
  ) {
    this.notificationDefer = this.$q.defer<number[]>();
    this.loadData();
  }

  public isChecked(id: number): boolean {
    return this.indexOf(id) >= 0;
  }

  public get idsToCompare(): number[] {
    return this.compareIds;
  }

  public toggle(id: number): void {
    this.isChecked(id) ? this.unCheck(id) : this.check(id);
  }

  public clearAll(ids: number[]): void {
    ids.forEach((id) => this.notify(CompareCheckboxAction.Removed, id));
    this.compareIds = [];
    this.recordData();
  }

  public subscribe(): ng.IPromise<number[]> {
    return this.notificationDefer.promise;
  }

  private notify(action: CompareCheckboxAction, id: number): void {
    const notification: INotficationItem = { action, id };
    this.notificationDefer.notify(notification);
  }

  private unCheck(id: number): void {
    if (this.isChecked(id)) {
      this.compareIds.splice(this.indexOf(id), 1);
      this.recordData();
      this.notify(CompareCheckboxAction.Removed, id);
    }
  }

  private check(id: number): void {
    if (!this.isChecked(id) && !this.isFull) {
      this.compareIds.push(id);
      this.recordData();
      this.notify(CompareCheckboxAction.Added, id);
      return;
    }

    this.notify(CompareCheckboxAction.IsFull, id);
  }

  private indexOf(id: number): number {
    return this.compareIds.indexOf(id);
  }

  private loadData(): void {
    const data = JSON.parse(this.$window.sessionStorage.getItem(key));
    this.compareIds = data ? data : [];
  }

  private recordData(): void {
    this.$window.sessionStorage.setItem(key, JSON.stringify(this.compareIds));
  }

  private get isFull(): boolean {
    return this.compareIds.length === maxIds;
  }
}
